import httpClient from "@/services/base.service.js";

export default {
  getAll: function () {
    return httpClient.get("/api/v1/serviceregion/get");
  },
  getById: function (id) {
      return httpClient.get("/api/v1/serviceregion/get/" + id);
  },
  save: function ({ data, isEdit }) {
      let http = isEdit ? 'put' : 'post'
      let url = isEdit ? '/api/v1/serviceregion/put/' + data.id : '/api/v1/serviceregion/post';
      return httpClient({ method: http, url: url, data: data });
  },
  delete: function (id) {
      return httpClient.delete("/api/v1/serviceregion/delete/" + id);
  }
};
